import { MoveableObject } from 'foundations-components/transitional/components/MoveableObject';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Box } from 'foundations-components/transitional/components/Box';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { View } from 'foundations-components/transitional/components/View';
import { DeleteIcon } from 'foundations-assets/icons/components/DeleteIcon';
import { EditIcon } from 'foundations-assets/icons/components/EditIcon';
import { PaymentSubscriptionsIcon } from 'foundations-assets/icons/components/PaymentSubscriptionsIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PaymentLinkButton = ({
  label,
  onEdit,
  onDelete
}) => /*#__PURE__*/_jsxs(TFlex, {
  marginBlock: "200",
  children: [/*#__PURE__*/_jsx(Box, {
    children: /*#__PURE__*/_jsxs(MoveableObject, {
      draggable: false,
      closeable: false,
      children: [/*#__PURE__*/_jsx(View, {
        as: "span",
        marginInlineEnd: "200",
        children: /*#__PURE__*/_jsx(PaymentSubscriptionsIcon, {})
      }), label]
    })
  }), /*#__PURE__*/_jsx(Box, {
    marginInlineStart: "200",
    children: /*#__PURE__*/_jsx(IconButton, {
      onClick: onEdit,
      children: /*#__PURE__*/_jsx(EditIcon, {})
    })
  }), /*#__PURE__*/_jsx(Box, {
    marginInlineStart: "200",
    children: /*#__PURE__*/_jsx(IconButton, {
      onClick: onDelete,
      children: /*#__PURE__*/_jsx(DeleteIcon, {})
    })
  })]
});
export default PaymentLinkButton;